const PeopleItems = [
    { "label": "爸爸", "icon": require('../icons/People/爸爸.png'), "isFolder": false },
    { "label": "妈妈", "icon": require('../icons/People/妈妈.png'), "isFolder": false },
    { "label": "全家", "icon": require('../icons/People/全家.png'), "isFolder": false },
    { "label": "兄弟/姐妹", "icon": require('../icons/People/兄弟姐妹.png'), "isFolder": false },
    { "label": "朋友", "icon": require('../icons/People/朋友.png'), "isFolder": false },
    { "label": "医生", "icon": require('../icons/People/医生.png'), "isFolder": false },
    { "label": "护士", "icon": require('../icons/People/护士.png'), "isFolder": false },
    { "label": "护工", "icon": require('../icons/People/护工.png'), "isFolder": false },
    { "label": "返回", "icon": require('../icons/HOME.png'), "isFolder": true }
  ];
  
  export default PeopleItems;